<span class="controlWrapper dateWrapper custom-datepicker">
  <span class="controlLiner">

    <label *ngIf="!ariaLabelledBy"
           class="screenReaderText sr-only"
           [id]="inputId + '_label'">
      {{ screenReaderLabel }}
    </label>

    <span [id]="inputId + '_desc'" class="sr-only">
      Date format should be {{ placeholder }}. Use arrow keys to navigate the calendar dates once opened.
    </span>

    <p-calendar #tgCalendar
                [formControl]="control"
                [inputId]="inputId"
                [dateFormat]="primeDateFormat"
                [placeholder]="placeholder"
                [showIcon]="true"
                [disabledDays]="disabledDays"
               
                [selectionMode]="selectionMode" 
                [view]="view"
                rangeSeparator=","
                [showOnFocus]="false"
                (onSelect)="onDateSelect($event)"
                (onInput)="onManualInput($event)"
                (onShow)="applyAccessibilityFixes()"
                (onMonthChange)="onCalendarNavigate()"
                (onYearChange)="onCalendarNavigate()"
                (onClose)="onCalendarHide()" 
                [attr.aria-describedby]="inputId + '_desc'"
                appendTo="body"
                styleClass="tg-structural-calendar"
                panelStyleClass="tg-solid-calendar-panel">
    </p-calendar>

    <!-- Polite: calendar open, month navigation, general status -->
    <div aria-live="polite" aria-atomic="true" class="sr-only">{{ a11yAnnouncement }}</div>
    <!-- Assertive: date selected — interrupts immediately so parent DOM update doesn't race ahead -->
    <div aria-live="assertive" aria-atomic="true" class="sr-only">{{ a11yDateAnnouncement }}</div>

  </span>
</span>